import React, { ReactNode, useEffect, useRef } from "react";

import { useScrollNavigation } from "./useScrollNavigation";

interface ScrollSectionProps {
    id: string;
    children: ReactNode;
}

export const ScrollNavigationSection = ({ id, children }: ScrollSectionProps): JSX.Element => {
    const ref = useRef(null);
    const { registerSection } = useScrollNavigation();

    useEffect(() => {
        if (ref.current) {
            registerSection(id, ref.current);
        }
    }, [id, registerSection]);

    return (
        <section ref={ref} id={id}>
            {children}
        </section>
    );
};
